import React from 'react';
import { Radio, InputNumber, message } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { ColumnProps } from 'antd/lib/table';
import intl from 'react-intl-universal';

import { IGoodsList } from '@/api/inventory';
import { CHECK_TYPE_MAP } from '@/config/constant';

import styles from './index.module.scss';

type inventoryType = 1 | 2 | 3 | null;

export const getTypeText = (type: inventoryType) => {
  return CHECK_TYPE_MAP[type] || '--';
};

export const COMPUTER_STATUS = [
  { label: intl.get('config_constant_computer_status_1'), value: 1 },
  { label: intl.get('config_constant_computer_status_2'), value: 2 },
];

interface IToalConsum {
  totalNum: number;
  totalPrice: number;
}
// 商品总消耗计算
export const calGoodsTotalConsum: (goodsList: IGoodsList[]) => IToalConsum = (goodsList) => {
  let totalNum = 0;
  let totalPrice = 0;

  if (!goodsList || goodsList.length === 0) {
    return { totalNum, totalPrice };
  }

  // eslint-disable-next-line array-callback-return
  goodsList.map((item) => {
    totalNum += item.consumeQty;
    totalPrice += item.consumeQty * item.price;
  });

  return { totalNum, totalPrice };
};

// 表格数据
export const getComputerColumns: (
  manualCheckChange: (params: { computerId: bigint; manualCheck: 1 | 2 | null }) => void,
  isResult: boolean,
) => ColumnProps<any>[] = (manualCheckChange, isResult) => {
  return [
    {
      title: intl.get('cmp_inventory_computer_column_no'),
      dataIndex: 'no',
      key: 'no',
    },
    {
      title: intl.get('cmp_inventory_computer_column_check'),
      dataIndex: 'selfCheck',
      key: 'selfCheck',
      render: (value) => {
        switch (value) {
          case 1:
            return <span>{intl.get('cmp_inventory_computer_content_check1')}</span>;
          case 2:
            return <span>{intl.get('cmp_inventory_computer_content_check2')}</span>;
          case 3:
            return (
              <span className={styles.abnormal}>
                {intl.get('cmp_inventory_computer_content_check3')}
              </span>
            );
          case 4:
            return (
              <span className={styles.abnormal}>
                {intl.get('cmp_inventory_computer_content_check4')}
              </span>
            );
          default:
            return '--';
        }
      },
    },
    {
      title: intl.get('cmp_inventory_computer_column_manual'),
      dataIndex: 'manualCheck',
      key: 'manualCheck',
      align: 'center',
      render: (value, record) => {
        if (isResult) {
          if (value === 1) return intl.get('config_constant_computer_status_1');
          if (value === 2)
            return (
              <span className={styles.abnormal}>
                {intl.get('config_constant_computer_status_2')}
              </span>
            );
          return '--';
        }
        return (
          <Radio.Group
            className={styles.radioTab}
            options={COMPUTER_STATUS}
            onChange={(e) => {
              manualCheckChange({ computerId: record.computerId, manualCheck: e.target.value });
            }}
            value={value}
            optionType="button"
          />
        );
      },
    },
  ];
};

export interface IChangeConsumeQty {
  type: 'add' | 'reduce' | 'change';
  skuCode: string;
  consumeQty?: number;
}

export const getGoodsConsumColumns: (
  changeConsumeQty: (params: IChangeConsumeQty) => any,
  isResult: boolean,
) => ColumnProps<any>[] = (changeConsumeQty, isResult) => {
  // 输入框输入
  const inputNumberConfirm = (e: any, record: any) => {
    const val = e.target.value;
    // 整数校验
    if (!/(^[0-9]\d*$)/.test(val)) {
      message.warn(intl.get('cmp_inventory_error_value_invalid'));
    } else {
      changeConsumeQty({ type: 'change', skuCode: record.skuCode, consumeQty: Number(val) });
    }
  };
  // 查房结果才会显示的列
  const resultColumns = [
    {
      title: intl.get('cmp_inventory_consume_column_remain'),
      dataIndex: 'remainQty',
      key: 'remainQty',
      align: 'center',
    },
  ];
  return [
    {
      title: intl.get('cmp_inventory_consume_column_spu'),
      dataIndex: 'spuName',
      key: 'spuName',
    },
    {
      title: '',
      dataIndex: 'skuName',
      key: 'skuName',
    },
    {
      title: intl.get('cmp_inventory_consume_column_last'),
      dataIndex: 'lastRemainQty',
      key: 'lastRemainQty',
      align: 'right',
    },
    ...(isResult ? resultColumns : []),
    {
      title: intl.get('cmp_inventory_consume_column_consume'),
      dataIndex: 'consumeQty',
      key: 'consumeQty',
      align: 'center',
      render: (value, record) => {
        if (isResult) return value;
        return (
          <div className={styles.changeNumber}>
            <span
              className={styles.btnWrapper}
              onClick={() => {
                changeConsumeQty({ type: 'reduce', skuCode: record.skuCode });
              }}
            >
              <MinusOutlined style={{ fontSize: '14px', color: ' #323233' }} />
            </span>
            <InputNumber
              controls={false}
              value={value}
              className={styles.number}
              min={0}
              onPressEnter={(e: any) => {
                inputNumberConfirm(e, record);
              }}
              onBlur={(e: any) => {
                inputNumberConfirm(e, record);
              }}
            />
            <span
              className={styles.btnWrapper}
              onClick={() => {
                changeConsumeQty({ type: 'add', skuCode: record.skuCode });
              }}
            >
              <PlusOutlined style={{ fontSize: '14px', color: ' #323233' }} />
            </span>
          </div>
        );
      },
    },
  ];
};

export const getPheripheralReturnColumns: (
  changeReturnQty: (params: IChangeConsumeQty) => any,
  isResult: boolean,
) => ColumnProps<any>[] = (changeReturnQty, isResult) => {
  // 输入框输入
  const inputNumberConfirm = (e: any, record: any) => {
    const val = e.target.value;
    // 整数校验
    if (!/(^[0-9]\d*$)/.test(val)) {
      message.warn(intl.get('cmp_inventory_error_value_invalid'));
    } else {
      changeReturnQty({ type: 'change', skuCode: record.skuCode, consumeQty: Number(val) });
    }
  };

  return [
    {
      title: '外设名称',
      dataIndex: 'spuName',
      key: 'spuName',
    },
    {
      title: '总租借次数',
      dataIndex: 'totalTimes',
      key: 'totalTimes',
      align: 'right',
    },
    {
      title: '房间库存',
      dataIndex: 'qty',
      key: 'qty',
      align: 'right',
    },
    {
      title: '归还数量',
      dataIndex: 'returnQty',
      key: 'returnQty',
      align: 'center',
      render: (value, record) => {
        // 查房结果直接返回值
        if (isResult) return value;
        return (
          <div className={styles.changeNumber}>
            <span
              className={styles.btnWrapper}
              onClick={() => {
                changeReturnQty({ type: 'reduce', skuCode: record.skuCode });
              }}
            >
              <MinusOutlined style={{ fontSize: '14px', color: ' #323233' }} />
            </span>
            <InputNumber
              controls={false}
              value={value}
              className={styles.number}
              min={0}
              onPressEnter={(e: any) => {
                inputNumberConfirm(e, record);
              }}
              onBlur={(e: any) => {
                inputNumberConfirm(e, record);
              }}
            />
            <span
              className={styles.btnWrapper}
              onClick={() => {
                changeReturnQty({ type: 'add', skuCode: record.skuCode });
              }}
            >
              <PlusOutlined style={{ fontSize: '14px', color: ' #323233' }} />
            </span>
          </div>
        );
      },
    },
  ];
};
